import { CheckDetailActions } from 'actions'
import { Link } from 'react-router'
import { UrlHelpers, SeoHelpers } from 'helpers'
import { Nav, Loading, VerdictBlock, Button, HelpEmail } from 'components'
import { ResponsiveDialog } from 'common-frontend'
import TextField from 'material-ui/TextField'
import IconButton from 'material-ui/IconButton'
import FontIcon from 'material-ui/FontIcon'
import Replay from 'material-ui/svg-icons/av/replay'
import ActionSettings from 'material-ui/svg-icons/action/settings'
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back'
import HelpOutline from 'material-ui/svg-icons/action/help-outline'
import FormsyText from 'formsy-material-ui/lib/FormsyText'
import Formsy from 'formsy-react'
import isURL from 'validator/lib/isURL'
import { validations } from 'consts'

import Enum from 'utils/Enum'

import './detailsHeader.scss'

export default class DetailsHeader extends React.Component {
  static contextTypes = {
    muiTheme: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired
  }

  static propTypes = {
    checkType: React.PropTypes.object.isRequired,
    result: React.PropTypes.object.isRequired,
    adhocUrl: React.PropTypes.string
  }

  constructor(props) {
    super(props)

    this.state = {
      showHelpModal: false,
      showUrlChangeModal: false
    }
  }

  mapInputs(inputs) {
    return { url: inputs.url }
  }

  componentWillMount() {
    // See the 'BUG' note below
    Formsy.addValidationRule('isUrl', (_, value) => isURL(String(value)))
  }

  refresh() {
    if (this.props.adhocUrl && this.props.adhocUrl !== null)
      CheckDetailActions.fetchAdhoc(this.props.checkType.id, this.props.adhocUrl)
    else
      CheckDetailActions.fetch({ id: this.props.checkType.id, refresh: true })
  }

  onUrlClick() {
    if (this.props.checkType.canAdhocCheck)
      this.setState({ showUrlChangeModal: true })
  }

  closeUrlChangeModal() {
    this.setState({ showUrlChangeModal: false })
  }

  submitForm() {
    this.refs.formsyform.submit()
  }

  getAdhocCheck({ url }) {
    this.setState({ showUrlChangeModal: false })
    CheckDetailActions.fetchAdhoc(this.props.checkType.id, url)
  }

  render() {
    let result = this.props.result

    if (result.isEmpty()) {
      return (
        <div>
          <Nav toolbarTitleText={`Checking ${this.props.checkType.name}...`}/>
          <Loading />
        </div>
      )
    }


    let urlStyles = {}
    if (this.props.checkType.id == Enum.CheckTypes.seoproblems.id) {
      urlStyles = {
        cursor: 'pointer',
        color: '#5A8FAB'
      }
    }

    let palette = this.context.muiTheme.palette

    // BUG: removed the two lines below from the 'Enter a different URL to check' form
    //      because they're causing production to break- can't enter anything into the textbox.
    //      Should reinstate when the switchover is done.
    // validations='isUrl'
    // validationError={validations.url}

    let refreshButton = (
      <IconButton key='refresh' iconClassName="material-icons" iconStyle={{ color: palette.alternateTextColor }} tooltip='refresh this check' onTouchTap={::this.refresh}>
        refresh
      </IconButton>
    )
    if (result.get('executeResult') === 'informationRequired' || result.get('executeResult') === 'upgradeRequired')
      refreshButton = null

    let setupButton = (
      <Link key='setup' to={`/checks/setup/${this.props.checkType.key}`}>
        <IconButton tooltip='setup' iconClassName="material-icons" iconStyle={{ color: palette.alternateTextColor }}>
          settings
        </IconButton>
      </Link>
    )
    if (result.get('executeResult') === 'upgradeRequired')
      setupButton = null

    return (
      <div>
        <Nav toolbarTitleText={`${result.get('descriptionFriendly')}`}
          rightGroupComponents={[
            <IconButton key='help' tooltip='help' iconClassName="material-icons" iconStyle={{ color: palette.alternateTextColor }} onTouchTap={() => this.setState({ showHelpModal: true })}>
              help
            </IconButton>,
            refreshButton,
            setupButton
          ]}
        />
        <div className='detailsHeader__url-container subhead' style={{ color: palette.alternateTextColor, backgroundColor: palette.accent2Color }}>
          <span className='detailsHeader__url-text label'>
            {result.get('finalUri')}
          </span>
          <IconButton className='detailsHeader__url__edit'
            key='detailsheadercheckanother'
            tooltip='check another'
            iconClassName="material-icons"
            iconStyle={{ color: palette.alternateTextColor }}
            style={{ padding: '0 12px', height: 'auto', verticalAlign: 'sub', display: this.props.checkType.canAdhocCheck === true && result.get('executeResult') !== 'informationRequired' && result.get('executeResult') !== 'upgradeRequired' ? 'default' : 'none' }}
            onTouchTap={::this.onUrlClick}>
            edit
          </IconButton>
        </div>
        <VerdictBlock checkType={this.props.checkType} result={result} />

        <ResponsiveDialog
          title="How to use the checker"
          modal={false}
          open={this.state.showHelpModal}
          onRequestClose={() => this.setState({ showHelpModal: false })}
          maxWidth="650px"
        >
          <div>
            <h3 className="xlarge-spacing2--top">Getting setup</h3>
            <ol>
              <li><p className="medium-spacing--top">Push <FontIcon className="material-icons in-text-icon" style={{fontSize: 20}}>settings</FontIcon> to set up the check. Here you enter, for example, the website URL you&apos;d like checked.</p></li>
              <li>
                <p>
                  <p className="medium-spacing">View the verdict which will tell you whether or not the problems found will be worthwhile for you to fix.</p>
                  <p className="small-spacing2">For example:</p>
                  <div className="how-to-use__verdict-example">
                    <h5>Maybe worthwhile to fix</h5>
                  </div>
                </p>
              </li>
              <li><p className="medium-spacing--top">Underneath this the rest of the page details what has been checked, any problems found and how to fix them.</p></li>
              <li><p className="medium-spacing--top"> When you&apos;ve fixed a problem, push <FontIcon className="material-icons in-text-icon" style={{fontSize: 20}}>refresh</FontIcon> to re-check.</p></li>
            </ol>
            <h3 className="xlarge-spacing2--top">Checking other urls</h3>
            <p className="medium-spacing--top">
              You can also push <FontIcon className="material-icons in-text-icon" style={{fontSize: 20}}>edit</FontIcon> to run a one-off check for a particular page on your site without changing your set up.
            </p>
            <h3 className="xlarge-spacing2--top">Get more help</h3>
            <p className="medium-spacing--top xlarge-spacing2--bottom">If you have any further questions you can email us at <HelpEmail />. We'd be happy to help you out.</p>
            <Button
              label='Close'
              buttonType="secondary"
              onTouchTap={() => this.setState({ showHelpModal: false })}
            />
          </div>
        </ResponsiveDialog>

        <ResponsiveDialog
          title="Enter a different URL to check"
          modal={true}
          open={this.state.showUrlChangeModal}
          onRequestClose={::this.closeUrlChangeModal}
          maxWidth="500px"
        >
          <div>
            <p className="medium-spacing2 body2">You can check any other URL here, it doesn&apos;t change the regular checking of your website.</p>
            <Formsy.Form onValidSubmit={::this.getAdhocCheck} ref='formsyform'>
              <FormsyText
                fullWidth={true}
                name='url'
                required
                hintText="Enter a URL"
              />
            </Formsy.Form>
            <div className="large-spacing2--top">
              <Button
                key='changeurlcheck'
                label='Check'
                buttonType="primary"
                onTouchTap={::this.submitForm}
              />
              <Button
                key='changeurlcancel'
                label='Cancel'
                buttonType="secondary"
                onTouchTap={::this.closeUrlChangeModal}
                className="secondary-btn"
              />
            </div>
          </div>
        </ResponsiveDialog>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/checks/DetailsHeader.js